import { ADD_KLAUSUR } from "../actions/types";

export default function rootReducer(state = {}, action) {
    // console.log({action});
    switch (action.type) {
        case ADD_KLAUSUR:
        if(!action.klausur)return state;
        return{...action.klausur}
        default:
          return state;
    };
};